import { defineMessages } from '@atlassian/jira-intl';

export const filterByRolesText = defineMessages({
	clickToFilterByRoles: {
		id: 'users-and-roles.roles-filter-container.roles-filter.click-to-filter-by-roles',
		defaultMessage: 'Roles',
		description: 'Dropdown label. Is shown to user when they didnt apply any roles filter.',
	},
	openLabel: {
		id: 'users-and-roles.roles-filter-container.roles-filter.open-label',
		defaultMessage: 'Open Roles Dropdown',
		description:
			'Dropdown icon label. Is shown to accessibility technologies for opening a roles dropdown which can be used to actors based on roles.',
	},
	buttonLabel: {
		id: 'users-and-roles.roles-filter-container.roles-filter.button-label',
		defaultMessage: 'Select Role',
		description:
			'Button label. Is shown to accessibility technologies for button of a roles dropdown which can be used to actors based on roles.',
	},
});
